import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';

@Component({
  name: 'bpc-entity-type-select',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class EntityTypeSelect extends mixins(AbstractField) {
  @Prop([String]) readonly value: string;
  @Prop({ type: String, default: 'entity-structure' }) readonly context: string;
  @Prop(Object) readonly formModel: AnyEntity;

  options: object[] = [];
  loading: boolean = false;

  get model(): string {
    return this.value;
  }
  set model(val: string) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  created() {
    this.getOptions();
  }

  getOptions() {
    this.loading = true;
    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityTypesConfigPath(this.context), {
        params: { template_type: this.formModel?.type },
      })
      .subscribe(res => {
        this.options = this.translateOptionsData(res.data);
        this.loading = false;
      });
  }

  translateOptionsData(data) {
    data.forEach(element => {
      element.text = this.$t(element.text);
    });
    return data;
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  get formModelType() {
    return this.formModel?.type;
  }

  @Watch('formModelType')
  onChangeModelType() {
    this.getOptions();
  }
}
